import { gql } from '@apollo/client';

const GET_CHAT_AUTHORIZATION_TOKEN = {
  query: gql`
    query GetChatAuthorizationToken($driverId: ID!) {
      getChatAuthorizationToken(driverId: $driverId) {
        jwt
      }
    }
  `,
  policies: {
    fetchPolicy: 'no-cache',
  },
};

export default GET_CHAT_AUTHORIZATION_TOKEN;
